import {
  AmountCell,
  CountCell,
  danger,
  DateCell,
  EyeIcon,
  modalHandler,
  NameCell,
  PhoneCell,
  Tooltip,
} from "@";
import { getCart } from "../utils/api";

export const TableActions = ({ id, setLoadingCart, setCart }) => {
  const showCartDetails = async (id) => {
    try {
      setLoadingCart(true);
      setCart([]);
      modalHandler();
      const { data: cart } = await getCart(id);
      setCart(cart);
    } catch (error) {
      danger("خطأ في عرض السلة, يرجى المحاولة مرة أخرى");
    } finally {
      setLoadingCart(false);
    }
  };

  return (
    <>
      <span
        className="icon-style"
        data-tooltip-placement="right"
        onClick={() => showCartDetails(id)}
        data-tooltip-target={`cart-${id}`}
      >
        <EyeIcon className="w-6" />
      </span>
      <Tooltip title="عرض تفاصيل السلة" id={`cart-${id}`} />
    </>
  );
};

// TanStack columns — used by the main listing in ./Index.jsx
export const tableColumns = [
  {
    id: "donorName",
    header: "اسم المتبرع",
    size: 180,
    cell: ({ row }) => <NameCell name={row.original.donorName} />,
  },
  {
    id: "phoneNumber",
    header: "رقم الجوال",
    size: 140,
    cell: ({ row }) => <PhoneCell phone={row.original.phoneNumber} />,
  },
  {
    id: "createdOn",
    header: "تاريخ الإضافة للسلة",
    size: 170,
    cell: ({ row }) => <DateCell value={row.original.createdOn} />,
  },
  {
    id: "itemCount",
    header: "الكمية",
    size: 100,
    cell: ({ row }) => (
      <CountCell value={row.original.itemCount} label="عنصر" />
    ),
  },
  {
    id: "totalPrice",
    header: "مبلغ التبرع",
    size: 130,
    cell: ({ row }) => (
      <AmountCell value={row.original.totalPrice} tone="emerald" />
    ),
  },
];

// react-data-table-component columns — used by the cart-detail modal (`ShowCart`)
// which still renders the legacy `<Table />`. Keep this format until the modal
// is migrated.
export const cardShowColumns = [
  {
    name: " اسم المشروع",
    cell: ({ projectName }) => <NameCell name={projectName} />,
  },
  {
    name: "الكمية",
    cell: ({ quantity }) => <CountCell value={quantity} label="عنصر" />,
  },
  {
    name: "مبلغ التبرع",
    cell: ({ totalPrice }) => (
      <AmountCell value={totalPrice} tone="emerald" />
    ),
  },
];
